var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTourIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 124,
    viewBox: "0 0 146 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_81_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.4995 61.5C69.062 61.5 66.1193 60.276 63.6714 57.8281C61.2235 55.3802 59.9995 52.4375 59.9995 49C59.9995 45.5625 61.2235 42.6198 63.6714 40.1719C66.1193 37.724 69.062 36.5 72.4995 36.5C75.937 36.5 78.8797 37.724 81.3276 40.1719C83.7756 42.6198 84.9995 45.5625 84.9995 49C84.9995 52.4375 83.7756 55.3802 81.3276 57.8281C78.8797 60.276 75.937 61.5 72.4995 61.5ZM47.4995 86.5V77.75C47.4995 75.9792 47.9558 74.3521 48.8683 72.8687C49.7808 71.3854 50.9912 70.2521 52.4995 69.4688C55.7287 67.8542 59.0099 66.6437 62.3433 65.8375C65.6766 65.0312 69.062 64.6271 72.4995 64.625C75.937 64.6229 79.3224 65.0271 82.6558 65.8375C85.9891 66.6479 89.2703 67.8583 92.4995 69.4688C94.0099 70.25 95.2214 71.3833 96.1339 72.8687C97.0464 74.3542 97.5016 75.9813 97.4995 77.75V86.5H47.4995Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9995 80V24C60.7995 35.2 103.166 28.6667 120 24V80C82.7995 64.8 41.8328 73.6667 25.9995 80Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 10.8834L70.5 2.88344C71.1667 2.21678 72.9 1.28344 74.5 2.88344C76.1 4.48344 80.5 8.88344 82.5 10.8834",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5 105L75 113C74.3333 113.667 72.6 114.6 71 113C69.4 111.4 65 107 63 105",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 49L139 57.5C139.667 58.1667 140.6 59.9 139 61.5C137.4 63.1 133 67.5 131 69.5",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8834 70.5L6.88344 62C6.21678 61.3333 5.28344 59.6 6.88344 58C8.48344 56.4 12.8834 52 14.8834 50",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_81_4",
    x: 0.5,
    y: 0.5,
    width: 144.884,
    height: 122.883,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_81_4"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_81_4",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourIcon);
export default __webpack_public_path__ + "static/media/tour-icon.a5a232cbb2dca9a8ad4670cc25f08b58.svg";
export { ForwardRef as ReactComponent };